import { useState } from "react";

// Brand SVGs inline (robust — no icon-package dependency that can break builds)
function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l-.999 3.648 3.737-.979zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.693.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413z" />
    </svg>
  );
}
function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  );
}
function TelegramIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
      <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  );
}
function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}
function LinkIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
    </svg>
  );
}

export default function ShareButtons({ url, title, compact = false }) {
  const [copied, setCopied] = useState(false);

  // Build absolute URL even if only a path is passed
  const shareUrl =
    url && url.startsWith("http")
      ? url
      : `https://aquinojapao.com${url || ""}`;
  const shareText = title ? `${title} — Aqui no Japão` : "Aqui no Japão";

  const enc = encodeURIComponent;
  const links = {
    whatsapp: `https://api.whatsapp.com/send?text=${enc(`${shareText}\n${shareUrl}`)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}`,
    telegram: `https://t.me/share/url?url=${enc(shareUrl)}&text=${enc(shareText)}`,
  };

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const ta = document.createElement("textarea");
      ta.value = shareUrl;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch {
        /* noop */
      }
      document.body.removeChild(ta);
    }
  }

  const base =
    "inline-flex items-center gap-2 rounded-full text-sm font-medium transition-all no-underline select-none";
  const pad = compact ? "px-3 py-1.5" : "px-4 py-2";

  return (
    <div
      className={`flex flex-wrap items-center gap-2 ${
        compact ? "" : "my-8 py-5 border-y border-border"
      }`}
    >
      {!compact && (
        <span className="text-sm text-ink-soft mr-1 font-medium">
          Compartilhe:
        </span>
      )}

      <a
        href={links.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className={`${base} ${pad} bg-[#25D366] text-white hover:brightness-105 hover:shadow-md`}
        aria-label="Compartilhar no WhatsApp"
      >
        <WhatsAppIcon />
        WhatsApp
      </a>

      <a
        href={links.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className={`${base} ${pad} bg-[#1877F2] text-white hover:brightness-105 hover:shadow-md`}
        aria-label="Compartilhar no Facebook"
      >
        <FacebookIcon />
        Facebook
      </a>

      <a
        href={links.telegram}
        target="_blank"
        rel="noopener noreferrer"
        className={`${base} ${pad} bg-[#229ED9] text-white hover:brightness-105 hover:shadow-md`}
        aria-label="Compartilhar no Telegram"
      >
        <TelegramIcon />
        Telegram
      </a>

      <button
        type="button"
        onClick={copyLink}
        className={`${base} ${pad} border border-border bg-surface text-ink hover:border-accent hover:text-accent`}
        aria-label="Copiar link"
      >
        {copied ? <CheckIcon /> : <LinkIcon />}
        {copied ? "Copiado!" : "Copiar link"}
      </button>
    </div>
  );
}
